import React, { useLayoutEffect, useReducer } from 'react';
import ACChargerFlex from '../ProductsLanding/03_ac_chargers_flex';
import AcChargers from './02_ac_chargers_title';
import DcChargerTitle from './04_dc_chargers_title';
import DcChargerFlex from '../ProductsLanding/05_dc_chargers_flex'
import Banners from './Banners';
import FourSteps from './FourSteps';
import CMS from './CMS';
import SimulatorTitle from './08_simulator_title';
import SimulatorFlex from '../ProductsLanding/09_simulator_flex';
import ConnectWithUs from './connectWithUs';
import FAQ from './Faq';
import StepsSection from '../../Molecules/StepsSection/StepsSection';
import DemoForm from '../../Molecules/DemoForm/DemoForm';
import ContactForms from '../Controllers/ContactForms';


function CPOs() {
    useLayoutEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, []);
      const [overlayActive, toggleOverlay] = useReducer((s) => !s, false);
  return (
    <>
        <Banners />
        <FourSteps />
        <AcChargers />
        <ACChargerFlex />
        <DcChargerTitle />
        <DcChargerFlex />
        <CMS toggleOverlay={toggleOverlay}/>
        <SimulatorTitle />
        <SimulatorFlex />
        <ConnectWithUs />
        <StepsSection />
        <FAQ />
        <ContactForms className="true"/> 

        {overlayActive && (
        <div className="fixed !m-0 inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ">
          <div className="bg-white rounded-2xl p-8 max-w-6xl w-full shadow-xl relative">
            <button
              onClick={toggleOverlay}
              className="absolute top-2 right-4 text-2xl font-bold text-gray-700"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4">Schedule Demo</h2>
            <div className='h-[95%]'>
              <DemoForm toggleOverlay={toggleOverlay}/>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CPOs